module.exports = __webpack_public_path__ + "public/Icons/logoutMobile.svg?5e52b517";